export * from './ThingDeleteMutation';
